import HBIcon from "@/components/HBIcon";
import HBSwiper from "@/components/HBSwiper";
import useAppStore from "@/context/store";
import imageUrl from "@/utils/imageUrl";
import { useMemo } from "react";
import { Else, If, Then, When } from "react-if";
import VipInfo from "../MaterialHeader/vip";
import TopicActions from "./Buttons";
import styles from "./index.module.less";

export default function TopicBanner({ topic, urlname, pinCount }) {
  const headerHeight = useAppStore((s) => s.headerHeight);

  const files = useMemo(() => {
    return topic?.contents?.slice(0, 3)?.map((content) => content.img) || [];
  }, [topic]);

  const themeColor = useMemo(() => {
    if (topic?.bgColor) {
      return topic.bgColor;
    }
    return files[0]?.theme ? `#${files[0]?.theme}` : "#FFB8BC";
  }, [files, topic]);

  return (
    <div className={styles.banner}>
      {/* 这里判断是因为取完数据再展示背景 */}
      <When condition={topic}>
        <div
          className={styles.bg}
          style={{
            backgroundColor: themeColor,
            top: `${headerHeight}px`,
          }}
        ></div>
      </When>

      <div className={styles.container}>
        <div className={styles.gallery}>
          <If condition={topic?.img}>
            <Then>
              <div className={styles.img}>
                <img src={topic?.img} alt="预览图" />
              </div>
            </Then>
            <Else>
              <If condition={files.length <= 1}>
                <Then>
                  <If condition={files[0]}>
                    <Then>
                      <div className={styles.img}>
                        <img
                          src={imageUrl(files[0], { width: 87 })}
                          srcSet={imageUrl(files[0], { width: 174 })}
                          alt="预览图"
                        />
                      </div>
                    </Then>
                    <Else>
                      <When condition={topic}>
                        <div
                          className={styles.text}
                          style={{ backgroundColor: themeColor }}
                        >
                          {topic?.title.slice(0, 2)}
                        </div>
                      </When>
                    </Else>
                  </If>
                </Then>
                <Else>
                  {[styles.imgFirst, styles.imgSecond, styles.imgThrid].map(
                    (className, index) => (
                      <div className={className} key={index}>
                        <img
                          src={imageUrl(files[index], { width: 87 })}
                          srcSet={imageUrl(files[index], { width: 174 })}
                          alt="预览图"
                        />
                      </div>
                    )
                  )}
                </Else>
              </If>
            </Else>
          </If>
        </div>
        <div className={styles.content}>
          <div className={styles.header}>
            <When condition={topic}>
              <HBIcon className={styles.logo} type="ic_tag" />
            </When>
            <div className={styles.name} data-topic-title>
              {topic?.title}
            </div>

            <div className={styles.actions}>
              <TopicActions topic={topic} urlname={urlname} reverse />
            </div>
          </div>
          <div className={styles.desc}>
            <span title={topic?.description}>
              {pinCount && pinCount > 20 ? `${pinCount} 个精选素材。` : null}
              {topic?.description}
            </span>
          </div>
          <When condition={topic?.labels?.length > 0}>
            <div className={styles.labels}>
              <div className={styles.title}>标签</div>
              <div className={styles.list}>
                <HBSwiper
                  className={styles.list}
                  iconClassName={styles.swiperIcon}
                >
                  {topic?.labels?.map((label) => (
                    <a
                      className={styles.item}
                      key={label.text}
                      href={`/search?type=material&q=${encodeURIComponent(
                        label.text
                      )}`}
                      data-gd-click="button_click"
                      data-gd-expose="resource_loc_expose"
                      data-resource-id={0}
                      data-button-name={label.text}
                      data-resource-title={label.text}
                      data-resource-type="文字链接"
                      target="_blank"
                    >
                      {label.text}
                    </a>
                  ))}
                </HBSwiper>
              </div>
            </div>
          </When>
        </div>
        <div className={styles.vipInfo}>
          <VipInfo />
        </div>
      </div>
    </div>
  );
}
